module.exports = __webpack_public_path__ + "img/spinner.d81bcae8.png";